<template>
  <div>
    <div class="uk-card uk-card-small uk-card-default">
      <div class="uk-card-header" style="background: #545454">
        <h3 class="uk-card-title" style="color: #fff">Sonderausstattung</h3>
      </div>
      <div class="uk-card-body">
        <div
          class="uk-grid uk-grid-small uk-grid-divider"
          data-uk-grid
        >
          <div class="uk-width-1-3@l uk-width-1-1@m">
            <ul class="uk-list uk-list-divider">
              <li>
                <span class="">Grundpreis:</span>
                <span class="uk-text-bold">{{ price | format }}</span>
              </li>
              <li>
                <span class=""
                  >Aufpreis für gewählte Sonderausstattung:</span
                >
                <span class="uk-text-bold">{{ selectedTotal | format}}</span>
              </li>
              <li>
                <span class="uk-text-bold uk-text-primary">Angebotspreis (gesamt)*:</span>
                <span class="uk-text-bold uk-text-primary">{{ total | format }}</span>
              </li>
            </ul>
            <div class="uk-margin-top">
            <p class="uk-text-small">
              <span v-if="taxReportable">inkl. MwSt.</span>
              <span v-else>MwSt. nicht ausweisbar</span><br>
              * Angebot freibleibend, solange der Vorrat reicht.
            </p>
            </div>
          </div>
          <div class="uk-width-expand">
            <ul data-uk-tab>
              <li v-for="(group, key) in grouped" :key="key">
                <a href="#">{{ key | matchKey }}</a>
              </li>
            </ul>
            <ul class="uk-switcher">
              <li v-for="(groups, key) in grouped" :key="key">
                <ul class="uk-list uk-list-striped uk-margin-remove">
                  <li
                    v-for="(item, i) in groups"
                    :key="i"
                    class="uk-margin-remove"
                  >
                    <div class="uk-flex uk-flex-between">
                      <div>
                        <label>
                          <input
                            class="uk-checkbox"
                            type="checkbox"
                            :value="item.id"
                            v-model="selected"
                          />
                          {{ item.text }}
                        </label>
                      </div>
                      <div>
                        <span class="uk-text-bold">
                          {{
                            item.prices.TO_CONSUMER.value
                              | euro(item.prices.TO_CONSUMER.vatIncluded)
                          }}
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import queryString from "query-string";
export default {
  props: {
    price: {
      required: true,
    },
    equipment: {
      required: true,
      type: Array,
    },
    taxReportable: {
      required: true
    }
  },
  watch: {
    selected: function (val, oldVal) {
      const dealerLinkEl = window.document.getElementById('eln-dealer-link')
      if(dealerLinkEl) {
        const url = new URL(dealerLinkEl.href)
        url.searchParams.delete('selected_equipments')
        url.searchParams.append('selected_equipments', val.join(','))
        dealerLinkEl.setAttribute('href', decodeURIComponent(url))
      }
    },
  },
  data() {
    return {
      selected: [],
    }
  },
  computed: {
    optional() {
      return _.filter(this.equipment, (e) => e.optional && e.text !== 'Abholung im Hauptsitz in 83416 Saaldorf-Surheim')
    },
    grouped() {
      return _.groupBy(this.optional, (o) => o.categoryTag)
    },
    total() {
      return parseFloat(this.price) + parseFloat(this.selectedTotal)
    },
    selectedTotal() {
      let price = 0
      _.forEach(this.selected, s => {
        const found = _.find(this.equipment, e => e.id === s)
        if(found) {
          price += found.prices.TO_CONSUMER.vatIncluded ? found.prices.TO_CONSUMER.value : found.prices.TO_CONSUMER.value * 1.19
        }
      })

      return price
    }
  },
  filters: {
    euro(value, vatIncluded) {
      const nf = new Intl.NumberFormat(['de-DE'], {
        style: 'currency',
        currency: 'EUR',
        maximumSignificantDigits: 4,
        maximumFractionDigits: 0
      })

      let price = value
      if (!vatIncluded) {
        price = value * 1.19
      }

      return nf.format(price)
    },
    format(value) {
      const nf = new Intl.NumberFormat(['de-DE'], {
        style: 'currency',
        currency: 'EUR',
        //maximumSignificantDigits: 2,
        //maximumFractionDigits: 0
      })
      return nf.format(value)
    },
    matchKey(key) {
      let label = ''
      if (key === 'INTERIOR') {
        label = 'Innen'
      }
      if (key === 'EXTERIOR') {
        label = 'Außen'
      }
      if (key === 'OTHER') {
        label = 'Sonstiges'
      }
      if (key === 'TIRES_CHASSIS') {
        label = 'Reifen / Fahrgestell'
      }
      if (key === 'INFOTAINMENT_MEDIA') {
        label = 'Infotainment/Media'
      }
      if (key === 'BUNDLES') {
        label = 'Pakete'
      }
      if(key === 'SAFETY') {
        label = 'Sicherheit'
      }
      if(key === 'UPHOLSTERIES') {
        label = 'Polster'
      }

      return label
    },
  },
}
</script>
